import SvgIcon from 'components/Icons/SvgIcon'
import React from 'react'
import { Alert as BootstrapAlert } from 'react-bootstrap'
import COLORS from 'utils/__enums/Common/Color'

interface Props {
  type: string
  alertMessaeg: string
  className?: string
  children?: React.ReactNode
}
function Alert({ type, alertMessaeg, className, children }: Props) {
  switch (type) {
    case 'success':
      return (
        <div>
          <BootstrapAlert
            variant="success"
            className={`alert wasteRegister__warning ${className}`}
          >
            <SvgIcon name="success" color={COLORS.SUCCESS} />
            <span>{alertMessaeg}</span>
          </BootstrapAlert>
        </div>
      )
    case 'warning':
      return (
        <div>
          <BootstrapAlert
            variant="warning"
            className={`alert wasteRegister__warning ${className}`}
          >
            <SvgIcon name="alert" color={COLORS.WARNING} />
            <span>{alertMessaeg}</span>
          </BootstrapAlert>
        </div>
      )
    case 'alert':
      return (
        <div className="alert__bottomGap">
          <BootstrapAlert
            variant="danger"
            className={`alert alert__danger ${className}`}
          >
            <SvgIcon name="alert" color={COLORS.DANGER} />
            {children ?? <span>{alertMessaeg}</span>}
          </BootstrapAlert>
        </div>
      )
    case 'info':
      return (
        <div className="alert__bottomGap">
          <BootstrapAlert variant="info" className={`alert__info ${className}`}>
            <SvgIcon name="infoCircleFull" color={COLORS.BLUE_SKY_LIGHT} />
            {children ?? <span>{alertMessaeg}</span>}
          </BootstrapAlert>
        </div>
      )
    default:
      return <></>
  }
}

Alert.defaultProps = {
  className: '',
  children: null,
}

export default Alert
